// TODO: reuse T component from @devographics/react-i18n
import React from 'react'
import { useI18n } from '@devographics/react-i18n'
// import ReactMarkdown from 'react-markdown'
// import rehypeRaw from 'rehype-raw'
import { useKeydownContext } from 'core/helpers/keydownContext'

const getGitHubSearchUrl = (k: string, localeId = 'en') =>
    `https://github.com/search?q=${k}+repo%3AStateOfJS%2Fstate-of-js-graphql-results-api+path%3A%2Fsrc%2Fi18n%2F${
        localeId || 'en'
    }%2F+path%3A%2Fsrc%2Fi18n%2Fen-US%2F&type=Code&ref=advsearch&l=&l=`

const markdownToHtml = (text: string): string => {
    if (!text) return ''
    // Split by double newlines to create paragraphs
    const paragraphs = text.split(/\n\n+/).filter(p => p.trim())
    return paragraphs
        .map(para => {
            const html = para
                .replace(/\n/g, '<br>')
                .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
                .replace(/\*(.+?)\*/g, '<em>$1</em>')
                .replace(/\[([^\]]+)\]\(([^)]+)\)/g, (match, text, url) => {
                    const href = url.startsWith('http://') || url.startsWith('https://') 
                        ? url 
                        : `https://${url}`
                    return `<a href="${href}">${text}</a>`
                })
            return `<p>${html}</p>`
        })
        .join('')
}

interface TProps {
    t?: string
    k: string
    values?: any
    md?: boolean
    html?: boolean
    isFallback?: boolean
    useShort?: boolean
    element?: string
    fallback?: string
}

export const T = ({
    t: override,
    k,
    values,
    md = false,
    html = false,
    fallback,
    isFallback = false,
    useShort = false,
    element
}: TProps) => {
    const { getString } = useI18n()
    const { modKeyDown } = useKeydownContext()

    // accept override to just use provided string as translation result
    let translation = override

    const props: any = {
        'data-key': k
    }
    const classNames = ['t']

    if (override) {
        classNames.push('t-override')
    } else {
        // FIXME: expects a fallabck value, not "isFallback boolean"
        const tFullString = getString(k, { values }, fallback) //isFallback)
        const tShortString = getString(`${k}.short`, { values }, fallback) // isFallback)

        const translationObject = useShort && !tShortString.missing ? tShortString : tFullString

        const handleClick = (e: React.MouseEvent<any>) => {
            // note: `fallback` here denotes whether a string is itself a fallback for a missing string
            if (modKeyDown) {
                e.preventDefault()
                e.stopPropagation()
                window.open(getGitHubSearchUrl(k, translationObject.locale.id))
            }
        }

        if (translationObject.t) {
            // If fallback is explicitly provided, always use it (for RecommendedResourcesBlock)
            // Otherwise use tHtml if available, or process t with markdownToHtml (for AboutBlock)
            if (fallback && translationObject.missing) {
                translation = md ? markdownToHtml(fallback) : fallback
            } else {
                translation = md
                    ? translationObject.tHtml || markdownToHtml(translationObject.t)
                    : translationObject.t
            }
        } else {
            props.onClick = handleClick
            props.title = 'Cmd/ctrl-click to add missing translation'
            classNames.push(modKeyDown ? 't-modkeydown' : 't-modkeyup')
            // FIXME we don't have isFallback anymore
            if (translationObject.isFallback) {
                // a translation was found, but it's a fallback placeholder
                translation = md ? translationObject.tHtml : translationObject.t
                classNames.push('t-isFallback')
            } else if (fallback) {
                translation = md ? markdownToHtml(fallback) : fallback
                classNames.push('t-providedFallback')
            } else {
                // no translation was found
                translation = `[${translationObject.locale.id}] ${k}`
                classNames.push('t-missing')
            }
        }
    }

    props.className = classNames.join(' ')

    //<ReactMarkdown rehypePlugins={[rehypeRaw]}>{t}</ReactMarkdown>

    const isHtml = md || html
    const Element = element ? element : isHtml ? 'div' : 'span'

    return isHtml ? (
        <Element {...props} dangerouslySetInnerHTML={{ __html: translation }} />
    ) : (
        <Element {...props}>{translation}</Element>
    )
}

export default T
